// Google Ads Conversion Tracking
export const trackWaConversion = () => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', {
      send_to: 'AW-11414123094/tTRLCJ_voPMaENbk1sIq',
      value: 0.0,
      currency: 'BRL',
    });
  }
};
